var common=require("./common.js");
var Toast=require("./toast.js");
var tycredidential=common.getQueryString("tycredidential");
var comment={
	el:$(".m-comment"),
	topicId:topicId,
	init:function(){
		var _this=this;
		this.el.find(".closeBtn").click(function(){
			_this.hide();
		})

		this.el.find("#commentTextArea").bind("input",function(){
			var count=$(this).val().length;
			_this.el.find(".limit").html(count+"/50");
		})
		this.el.find(".submitBtn").click(function(){
			_this.submit();
		})
	},
	submit:function(){
		var _this=this;
		var content=this.el.find("#commentTextArea").val();
		content=$.trim(content);
		if(content.length==0){
			new Toast("请输入回复内容");
			return;
		}
		// $.getJSON("/yubashuo/add-comment?topicId="+this.topicId+"&content="+encodeURIComponent(content)+"&tycredidential="+tycredidential,function(msg){
			
		// })
		$.ajax({
		    url:'/yubashuo/add-comment',
		    type:'POST',
		    data:{
		        topicId:this.topicId,
		        content:content,
		        tycredidential:tycredidential
		    },
		    dataType:'json',
		    success:function(msg){
		    	if(msg.resCode==11){
		    		common.login();
		    		return;
		    	}
		        if(msg.resCode!=0){
					new Toast(msg.resReason);
					return;
				}
				_this.hide();
				var source=$("#commentItem-template").html();
				var template=Handlebars.compile(source);
				var html=template({items:[msg.data]});
				window.main.addNewComment(html);
				canCommentCount--;
		    },
		    error:function(){
		    	new Toast("网络不可用，请稍后再试！");
		    }
		})
	},
	show:function(){
		$(".m-share").hide();
		$(".m-topic").hide();
		$(".m-bottomBar").hide();
		$("canvas").hide();
		this.el.show();	
		this.el.find("#commentTextArea").val("");
	},
	hide:function(){
		$(".m-topic").show();
		$(".m-bottomBar").show();
		this.el.hide();		
		this.el.find(".limit").html("0/50");		
	}
}
module.exports=comment;


//////////////////
// WEBPACK FOOTER
// ./pages/yubashuo/js/comment.js
// module id = 5
// module chunks = 2